<template>
    <div>
        <Title>设计归档</Title>
        <div class="panel">
            <div class="label">项目名称</div>
            <div class="value3">{{ extra.projectName }}</div>

            <div class="label">申请部门</div>
            <div class="value1">{{ extra.applyDeptName }}</div>
            <div class="label">阶段</div>
            <div class="value2">
                <DataDictFinder dictType="phase" :dictValue="extra.phaseId" />
            </div>

            <div class="label">标准化管理员</div>
            <div class="value3">{{ extra.standardManagerName }}</div>
        </div>
        <Title>问题及整改</Title>
        <div class="panel">
            <template v-for="item in stepFields">
                <div :key="item.field + '-label'" class="label full-label">{{ item.label }}</div>
                <div :key="item.field + '-value'" class="value4">
                    <a-textarea
                        v-if="item.taskKey === taskDefKey"
                        :value="extra[item.field]"
                        @input="e => $set(extra, item.field, e.target.value)"
                        :auto-size="{ minRows: 3 }"
                    />
                    <div v-else-if="extra[item.field]" class="readonly-text">{{ extra[item.field] }}</div>
                    <div v-else class="readonly-text empty">--</div>
                </div>
            </template>
        </div>
        <Padding />
    </div>
</template>

<script>
import { mapState } from "vuex";
import Title from "../Title";
export default {
    components: {
        Title,
    },
    computed: {
        ...mapState("approval", ["detail"]),
        extra() {
            return this.detail.extra ? this.detail.extra : {};
        },
        taskDefKey() {
            return this.detail.taskDefinitionKey;
        },
        stepFields() {
            const allSteps = [
                { taskKey: "chief_engineer", label: "质量问题", field: "qualityIssue" },
                { taskKey: "standard_manager", label: "贯标问题", field: "standardIssue" },
                { taskKey: "dept_leader_0", label: "资格审查问题", field: "qualificationIssue" },
                { taskKey: "design_leader", label: "整改说明", field: "rectificationDesc" },
            ];
            const currentIndex = allSteps.findIndex(s => s.taskKey === this.taskDefKey);
            return currentIndex >= 0 ? allSteps.slice(0, currentIndex + 1) : [];
        },
    },
};
</script>

<style lang="less" scoped>
.panel {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    border-top: 1px solid #e8e8e8;

    & > div {
        padding: 8px;
        border-bottom: 1px solid #e8e8e8;
    }

    .label {
        background-color: #fafafa;
        border-right: 1px solid #e8e8e8;
        border-left: 1px solid #e8e8e8;
    }

    .full-label {
        grid-column-start: 1;
        grid-column-end: 2;
    }

    .value1 {
        grid-column-start: 2;
        grid-column-end: 4;
    }

    .value2 {
        grid-column-start: 5;
        grid-column-end: 7;
        border-right: 1px solid #e8e8e8;
    }

    .value3 {
        grid-column-start: 2;
        grid-column-end: 7;
        border-right: 1px solid #e8e8e8;
    }

    .value4 {
        grid-column-start: 2;
        grid-column-end: 7;
        border-right: 1px solid #e8e8e8;
    }

    .readonly-text {
        padding: 4px 8px;
        min-height: 28px;
        line-height: 1.5;
        //background: #f5f5f5;
        border-radius: 2px;
        color: rgba(0, 0, 0, 0.65);
    }

    .readonly-text.empty {
        color: rgba(0, 0, 0, 0.25);
    }
}
</style>
